import { render, staticRenderFns } from "./cnpj-modal.vue?vue&type=template&id=22abb43e&"
import script from "./cnpj-modal.vue?vue&type=script&lang=ts&"
export * from "./cnpj-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports